export default class GCUMsgHandler {
  constructor(msg) {
    this.headers = msg.headers;
    this.command = this.headers.datatype.substring(0, 3);
    this.lcu = this.headers.datatype.substring(3);
    this.gcu = this.headers.gcuserial;
    this.body = JSON.parse(msg.body);
  }
}
